import React from "react";
import { Button, Form, Input, notification, Spin } from "antd";
import "./PlantSiteChampion.css";
import { SiteChampionFormLabels } from "../../Utils/constants";
import BasicFormItem from "../BasicFormItem/BasicFormItem";
import ButtonComp from "../ButtonComp/ButtonComp";
import { CheckCircleOutlined } from "@ant-design/icons";
import { PlantSiteChampionVar } from "../../Utils/variables";
import { useDispatch, useSelector } from "react-redux";
import { onSiteChampionSubmit } from "../../API-Interaction/apiServices/plants.api";
import moment from "moment";
import { antIcon } from "../../Helpers/helpers";

const { heading } = PlantSiteChampionVar

const PlantSiteChampion = () => {
  const [form] = Form.useForm();
  const { pageLoaders } = useSelector(state => state?.utils.loaders)
  let { plant = null } = useSelector(state => state?.plant?.current)
  console.log(plant)
  const formTailLayout = {
    labelCol: {
      span: 8,
    },
    wrapperCol: {
      span: 12,
    },
  };

  let dispatch = useDispatch()
  const onSubmitSC = (values) => {
    let siteChampion = values
    let body = {
      updatedAt: `${moment(Date.now()).format(`${"YYYY-MM-DDThh:mm:ss.ms"}`)}Z`,
      _id: plant?._id,
      siteChampion
    }
    onSiteChampionSubmit(dispatch, body)
    form.resetFields()

  }
  return (
    <Spin indicator={antIcon} spinning={pageLoaders?.siteChampion ? pageLoaders?.siteChampion : false}>

      <div className="dflex flexColumn gap20">
        <h1 className="pageHead">{heading}</h1>
        <div>
          <Form
            onFinish={onSubmitSC}
            form={form}
            onFinishFailed={(error) => console.log(error)}
            name="basic" layout="vertical">

            {SiteChampionFormLabels.map((items, index) => (
              <BasicFormItem key={index} props={items} />
            ))}
            <Form.Item {...formTailLayout}>
              <div className="form-button-div">
                <ButtonComp
                  theme="blue"
                  hmtlType="submit"
                  text="Save"
                  icon={<CheckCircleOutlined />}
                />
              </div>
            </Form.Item>
          </Form>
        </div>
      </div>
    </Spin>
  );
};

export default PlantSiteChampion;
